import { gql, useQuery } from "@apollo/client";

export const useLibraryVideos = (categoryId: string) => {
  return useQuery(gql`
    query getLibraryVideos($filter: FilterFindManyLibraryVideoInput) { 
      library_videos(filter: $filter) {
        _id
        name
        description
        status
        library_category_id
        video_id
        video_name
        from_reference
        using_organisation_ids
      }
    }
  `, {
    variables: {
      filter: {
        library_category_id: categoryId,
      }
    },
    fetchPolicy: "network-only",
  });
};